import { Injectable } from '@angular/core';
import { Language } from '@interfaces/language.interface';

@Injectable({
  providedIn: 'root',
})
export class LanguageHelper {
  constructor() {}

  public LANGUAGES: Language[] = [
    {
      id: 'pt-BR',
      title: 'Português',
      flag: 'pt',
      flagJitsi: 'ptBR',
    },
    {
      id: 'en-US',
      title: 'English',
      flag: 'us',
      flagJitsi: 'en',
    },
    {
      id: 'es-ES',
      title: 'Español',
      flag: 'es',
    },
  ];

  public defaultLanguageId = 'pt-BR';

  public setCurrentLanguageInStorage(languageId: string): void {
    localStorage.setItem('omnismart_lang', languageId);
  }

  public getCurrentLanguageFromStorage(): Language | undefined {
    const languageId = localStorage.getItem('omnismart_lang');
    if (languageId) return this.findLanguageById(languageId);
    return undefined;
  }

  public getAllLanguageIds(): string[] {
    return this.LANGUAGES.map((language) => language.id);
  }

  public findLanguageById(languageId: string): Language | undefined {
    return this.LANGUAGES.find((language) => language.id === languageId);
  }

  public getAllLanguages(): Language[] {
    return this.LANGUAGES;
  }

  public getDefaultLanguage(): Language | undefined {
    return this.findLanguageById(this.defaultLanguageId);
  }
  public getCurrentLanguageId(): string {
    const id = this.getCurrentLanguageFromStorage()?.id;
    if (id) return id;
    return this.defaultLanguageId;
  }
}
